import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson0DefaultStartCode = `// Welcome to Starklings: Cairo v1
// This lesson doesn't do anything yet but it still compiles! Every Cairo file
// needs to have a 'main' function.
// Other lessons will require you to write Cairo code to make the lesson file compile.

${doNotModifyCodeAbove}`;

export const lesson0DefaultMiddleCode = `fn main() {}`;

export const lesson0DefaultEndCode = `${doNotModifyCodeBelow}
#[test]
fn test_compile() {
    assert(1 == 1, 'Surprising');
    main();
}`;
